import { getFeatureConfig } from '@luna/feature-config';

const DEFAULT_DECIMAL_COUNT = 2;
const PERCENTAGE_BASE = 100;

export function formatPercentage(
    interestRate?: number | string,
    addPercentageSign?: boolean,
    decimals = DEFAULT_DECIMAL_COUNT,
    shouldRound = true,
): string {
    let formattedPercentage: string | number;

    const interestRateOrDefault = interestRate || 0;
    const addPercentageSignSave = addPercentageSign !== false ? ' %' : '';
    const { decimalSeparator } = getFeatureConfig(({ base }) => base);

    if (shouldRound) {
        formattedPercentage = (
            Math.round(+interestRateOrDefault * PERCENTAGE_BASE) / PERCENTAGE_BASE
        ).toFixed(decimals);
    } else {
        formattedPercentage = (+interestRateOrDefault * PERCENTAGE_BASE) / PERCENTAGE_BASE;
    }
    const result = `${formattedPercentage}${addPercentageSignSave}`;

    if (result.indexOf(decimalSeparator) === -1 && decimalSeparator) {
        return result.replace('.', decimalSeparator);
    }

    return result;
}
